import React, { FC } from 'react'
import clsx from 'clsx'

interface Props {
  className?: string
  author: Author
  meta: BlogMeta
}

const formatDate = (date: string) => {
  const dateObj = new Date(date)
  const day = dateObj.getDate()
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
  const year = dateObj.getFullYear().toString().slice(-2)
  return `${day}/${month}/${year}`
}

const BlogAuthorMeta: FC<Props> = ({ author, meta, className }) => {
  return (
    <div className={clsx(className)}>
      <div className="sm:text-paragraph-4 text-caption flex items-center flex-wrap">
        <div className="text-gray-90 font-medium">{author.name}</div>
        <div className="mx-2 text-gray-50">•</div>
        <div className="text-gray-60">
          Posted on {formatDate(meta.publishedDate)}
          <span className="mx-2 text-gray-50">•</span>
          {meta.readTime} min read
        </div>
      </div>
    </div>
  )
}

export default BlogAuthorMeta
